import { useQuery } from '@tanstack/react-query'
import { repository } from '../../data'
import { Icon } from '../icons'
import { Section } from '../primitives'
import { Link } from '../shell/Link'
import { DeliveryList } from './DeliveryList'

/**
 * Intake's block on Today: the one thing they came to do, and what came in
 * last. Compact on purpose — Today is a glance, Receive is where the work is.
 */
export function TodayReceiving(): JSX.Element {
  const recent = useQuery({ queryKey: ['receipts', 'recent', 3], queryFn: () => repository.receipts({ limit: 3 }) })

  return (
    <Section
      label="Deliveries"
      actions={
        <Link to={{ name: 'inventory' }} className="button inv-section-button">
          Inventory
        </Link>
      }
    >
      <Link to={{ name: 'receive', item: null }} className="button primary inv-today-go">
        <Icon name="receive" />
        Receive a delivery
      </Link>
      {recent.data && recent.data.length > 0 ? <DeliveryList receipts={recent.data} /> : null}
      {recent.data && recent.data.length === 0 ? <p className="muted inv-quiet">Nothing received yet.</p> : null}
    </Section>
  )
}
